import { NgModule } from '@angular/core';

import { DirectivesModule } from '../directives/directives.module';
import { CommonModule } from '@angular/common';
import { EyesInfoComponent } from './eyes-info/eyes-info';
import { IonicModule } from 'ionic-angular';
import { CustomCircleComponent } from './custom-circle/custom-circle';
import { CustomLineComponent } from './custom-line/custom-line';
import { CustomSquareComponent } from './custom-square/custom-square';
import { DeleteModalComponent } from './delete-modal/delete-modal';
import { HeaderComponent } from './header/header';


@NgModule({
    declarations: [
        EyesInfoComponent,
        CustomCircleComponent,
    CustomLineComponent,CustomSquareComponent,
    DeleteModalComponent,HeaderComponent
    ],
    imports: [
        DirectivesModule,
        CommonModule,
        IonicModule,
    ],
    exports: [
        EyesInfoComponent,
        CustomCircleComponent,
    CustomLineComponent,CustomSquareComponent,
    DeleteModalComponent,HeaderComponent
    ],
    entryComponents: [
        EyesInfoComponent   
    ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts